export default __webpack_public_path__ + "static/media/ic_search_black_24px.1c7d6aa8.svg";